import { App, View } from "@pimo/pimo-app-builder";
import {
  DragAndDropLayout,
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
  PMSmallNumberProps,
} from "@pimo/pimo-components";

import { TestAppState } from "../../../app";
import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import {
  getItemName,
  getPluralOfItemName,
} from "../../../utils/get-plural-of-item-name";
import { getProjectName } from "../../../utils/get-plural-of-project-name";
import { isFieldEnabled } from "../../field-enabled";
import { makeGetCardCopy } from "../card-copy";

/** Adds the number-of-due-items card (#2222). */
export function addNumberOfDueItemsCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const getCardCopy = makeGetCardCopy(app);

  const numberOfDueItemsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfDueItemsComponent",
      labels: ["#ofItems"],
      description: getCardCopy(language, "reportDueItems").description,
      title: getCardCopy(language, "reportDueItems").title,
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfDueItemsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "numberOfDueItemsComponent",
      labels: ["#ofItems"],
      title: getCardCopy(language, "reportDueItems").title,
      description: getCardCopy(language, "reportDueItems").description,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfDueItemsComponent.mapState(
    ({ currentReport, reportComponentValues, ...appState }) => {
      const a: PMSmallNumberProps | undefined = reportComponentValues?.[
        "numberOfDueItemsComponent"
      ] as PMSmallNumberProps | undefined;
      return {
        showInfoIcon: false,
        showMenuIcon: false,
        title:
          a?.title ??
          getLocalizedCardCopy(appState.language || "en", "reportDueItems", {
            itemName: getItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            itemNamePlural: getPluralOfItemName(
              appState.settings?.configuration?.itemName,
              appState.language || "en"
            ),
            projectName: getProjectName(
              appState.settings?.configuration?.projectName,
              appState.language || "en"
            ),
          }).title,
        number:
          a?.number ??
          currentReport?.project?._calculated?.numberOfOverdueSubEntities ??
          0,
      };
    }
  );

  // "Due" is derived from the items' end date — without that field there is
  // nothing to be overdue against.
  numberOfDueItemsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "endDate", "itemBasic")
  );
}
